import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import "firebase/database";
import "firebase/functions";

export const firebaseApp = firebase.initializeApp({
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID,
});

export const authWorker = firebase.initializeApp(
  {
    apiKey: process.env.VUE_APP_API_KEY,
    authDomain: process.env.VUE_APP_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_ID,
    measurementId: process.env.VUE_APP_MEASUREMENT_ID,
  },
  "Secondary",
);

export const firebaseAppXml = firebase.initializeApp({
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID
}, 'xmlHub')

// Database de afiliados usando o mesmo app principal (compartilha autenticação)
const databaseAffiliatesURL = process.env.VUE_APP_DATABASE_URL_AFFILIATES;
const databaseWppSyncURL = process.env.VUE_APP_DATABASE_URL_WPP_SYNC;

// Database do SimplesXML Web (notas fiscais)
// const databaseSimplesXmlURL = process.env.VUE_APP_AUTH_DOMAIN_XML;

export default function install(Vue) {
  Object.defineProperty(Vue.prototype, "$firebase", {
    get() {
      return firebaseApp;
    },
  });
  Object.defineProperty(Vue.prototype, "$authWorker", {
    get() {
      return authWorker;
    },
  });
  Object.defineProperty(Vue.prototype, "$firebaseAffiliates", {
    get() {
      return firebaseApp.database(databaseAffiliatesURL);
    },
  });
  Object.defineProperty(Vue.prototype, "$firebaseWppSync", {
    get() {
      return firebaseApp.database(databaseWppSyncURL);
    },
  });
  Object.defineProperty(Vue.prototype, "$firebaseSimplesXml", {
    get () {
      const xmlDatabaseUrl = process.env.VUE_APP_AUTH_DOMAIN_XML
      if (xmlDatabaseUrl && firebaseApp.auth().currentUser) {
        return firebaseApp.database(xmlDatabaseUrl)
      }
      return firebaseAppXml.database(xmlDatabaseUrl)
    }
  });
}
